import React from 'react'
import { Trans } from '@lingui/react'
import styled from 'styled-components'

import StartActivityForm from '../../activities-create/activity-start/StartActivityForm'

import ModalTopBar from '../../../layout/ModalTopBar'
import Modal, { ModalMainContainer } from '../../../layout/Modal'
import ModalConfirmButtonBar from '../../../layout/ModalConfirmButtonBar'

const StartActivityModal = ({ formState, onClose, onSubmit, isSubmitting }) => (
    <Modal
        data-testid="CreateActivityModal"
        ariaLabel="Create activity"
        islarge="true"
    >
        <ModalTopBar title={<Trans id="Start activity" />} onClose={onClose} />
        <StyledModalMainContainer>
            <StartActivityForm formState={formState} />
        </StyledModalMainContainer>
        <ModalConfirmButtonBar
            isSubmitting={isSubmitting}
            onCancel={onClose}
            onSubmit={onSubmit}
        />
    </Modal>
)

const StyledModalMainContainer = styled(ModalMainContainer)`
    min-height: 25rem;
`

export default StartActivityModal
